var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('edit-frame',{attrs:{"width":"100%","isEditing":_vm.editMode,"hideControls":true}},[_c('v-text-field',{attrs:{"required":"","type":"number","rules":[
      _vm.$validation.vuetify.single({
        numericality: {
          greaterThanOrEqualTo: 1,
          lessThanOrEqualTo: 2147483647,
        },
        presence: true,
      }),
    ],"label":"Anzahl der Stellplätze","outlined":"","dense":"","disabled":!_vm.editMode},on:{"input":_vm.onInput},model:{value:(_vm.editedCapacity),callback:function ($$v) {_vm.editedCapacity=_vm._n($$v)},expression:"editedCapacity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }